import { shouldDisplayProperty } from "PFApp/helpers/activity_form/should_display_property";
import { getVisibleProperties } from "PFCore/helpers/templates";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { Profile, Subtemplate, Template } from "PFTypes";
import { useCallback } from "react";

type GetVisiblePermittedPropertiesAttributes = {
  subtemplate?: Subtemplate | null;
  template?: Template | null;
  activityCreator: Profile | null;
};

export const useVisiblePermittedProperties = () => {
  const { data: currentProfile } = useCurrentProfile();
  const { customTypes } = useCustomTypes();

  const getVisiblePermittedProperties = useCallback(
    ({ subtemplate, template, activityCreator }: GetVisiblePermittedPropertiesAttributes) =>
      getVisibleProperties(subtemplate || template).filter(
        (property) =>
          property.type !== "custom_field" ||
          shouldDisplayProperty(property, customTypes, currentProfile, activityCreator)
      ),
    [currentProfile, customTypes]
  );

  return {
    getVisiblePermittedProperties
  };
};
